import service from '../config/services';


const { env, server } = service;
export function geOwnDomain() {
    let domain = server.test
    if (env === 4) {
        domain = server.product
    }
    return domain
}

export function getPayResultUrl(orderId, view = 'result') {
    const url = `${window.location.origin}${window.location.pathname}#/${view}?id=${orderId}`
    return url
}

//get page hash value
export function getUrlHashName() {
    const hash = window.location.hash
    if (!hash) return ''
    const hashPath = hash.split('?')[0]
    return hashPath
}
